import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import { MemberCreateRequestBody, MemberCreateResponse } from "./types";

export class MemberCreateAPI extends BaseAPI<
    MemberCreateRequestBody,
    MemberCreateResponse
> {
    protected route = ApiRoutes.member.create;
    protected method = RequestMethod.POST;
}
